/**
 * Created by neto on 2/21/17.
 */

import React, { PureComponent } from 'react'
import Switch from 'react-ios-switch'
import classnames from 'classnames'

import styles from './styles'

class SwitchForm extends PureComponent {

  onChange = e => {
    e.preventDefault()
    const nextChecked = !this.state.checked
    this.setState({
      checked: nextChecked
    })
    if (nextChecked) {
      this.props.input.onChange(this.state.checkboxValue)
    } else {
      this.props.input.onChange(null)
    }
  }

  render() {
    const { input, label, className, ...rest } = this.props
    return <div className={classnames('container', className)}>
      <label htmlFor={input.id}> {label}
        <Switch {...input} {...rest} checked={Boolean(this.props.input.value)} />
        <style jsx>{styles}</style>
      </label>
    </div>
  }
}

export { Switch as default, SwitchForm }
